import Model from '../../model/model';
import RefBooksList from './refbooks.list';
import Config from '../../config';
import Form from '../../view/form';
import Priority from '../../model/priority';
import Priorities from '../../collection/priorities';

import { ask, } from '../../utils/popups';
import { roleA, roleAC, roleC, roleAI } from '../../roles';
import { restrict } from '../../model/actions';





const FilterModel = Model.extend( { defaults: {
    cluster: undefined,
} } )

export default RefBooksList.extend( { 

    template: 'module/refbooks/priorities.list',

    url() {
        return 'priorities';
    },

    open() {
        const form = new Form( {
            template: 'module/refbooks/priorities.form',
            clusters: this.options.clusters,
        } );

        const actions = this.options.actions = {
            
            defaults: 'edit',
            
            create: restrict( roleAC, () => {
                const current = new Priority();
                const binding = form.bind( current );
                binding.then( () => {
                    if (this.state().cluster && this.state().cluster.id != -1)
                        current.set( 'cluster', this.state().cluster );
                    else if (~roleC.indexOf( Config.role() ))
                        current.set( 'cluster', Config.cluster() );
                } );

                ask( binding,
                    'priority::modal new - title', 'actions::create', 'actions::cancel', 
                    () => this.options.priorities.save( form ) )
                        .then( () => this.options.source.reset( this.options.priorities.models ) )
                        .then( () => this.sort() )
                        .then( () => this.render() );
            } ),
            
            edit: restrict( roleAC, 

                () => {
                    if (roleA.includes( Config.role() ))
                        return true;

                    // can see only "my" priorities: with cluster == my cluster;
                    // there are only global and "my" priorities in the list;
                    // so, let's check only presence of cluster in priority
                    // to separate "my".
                    return !!this.options.paged
                        .current().get( 'cluster' );
                },
        
                current => {
                    current = current.clone();
                    ask( form.bind( current ),
                        'priority::modal edit - title', 'actions::save', 'actions::cancel', 
                        () => this.options.source.save( form ) )
                            .then( () => this.sort() )
                            .then( () => this.render() );
            } ),
            
            destroy: restrict( roleAC,

                () => {
                    if (roleA.includes( Config.role() ))
                        return true;

                    // can see only "my" priorities: with cluster == my cluster;
                    // there are only global and "my" priorities in the list;
                    // so, let's check only presence of cluster in priority
                    // to separate "my".
                    return !!this.options.paged
                        .current().get( 'cluster' );
                },
        
                current => this.destroy( current, 
                    'priority::modal delete - title', 
                    'priority::modal delete - confirmation text' ) ),
            
        };

        this.options.filter = new FilterModel( { 
            cluster: this.state().cluster,
        } )

        this.options.source = new Priorities( this.options.priorities.models );
        this.options.sorted = new Priorities();
        this.options.filtered = new Priorities();
        this.options.paged = new Priorities( { actions, } );

        return this.sort().then( () => this.bind( this.options.filter ) );
    },

} );



// WEBPACK FOOTER //
// ./src/js/module/refbooks/priorities.list.js